"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _Branding = _interopRequireDefault(require("MeetingsBase/models/Branding"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _colors = require("HubStyleTokens/colors");

var height = '92px';

var _default = (0, _createReactClass.default)({
  displayName: "CompanyLogo",
  propTypes: {
    compact: _propTypes.default.bool,
    branding: _propTypes.default.instanceOf(_Branding.default).isRequired
  },
  hasLogo: function hasLogo() {
    var logoUrl = this.props.branding.logoUrl;
    return Boolean(logoUrl);
  },
  render: function render() {
    var _this$props = this.props,
        compact = _this$props.compact,
        _this$props$branding = _this$props.branding,
        logoUrl = _this$props$branding.logoUrl,
        logoAltText = _this$props$branding.logoAltText,
        companyName = _this$props$branding.companyName;
    var hasLogo = this.hasLogo();

    if (!hasLogo) {
      return null;
    }

    var classes = 'p-top-4' + (compact ? " m-bottom-4" : "");
    var alt = logoAltText;

    if (!logoAltText) {
      if (companyName) {
        alt = _I18n.default.text('prebook.brandingAltText', {
          companyName: companyName
        });
      } else {
        alt = _I18n.default.text('prebook.brandingAltTextNoCompany');
      }
    }

    return _react.default.createElement("div", {
      className: classes,
      style: {
        height: height,
        background: _colors.GYPSUM
      }
    }, _react.default.createElement(_UIImage.default, {
      className: "branding-company-logo m-x-auto",
      src: logoUrl,
      alt: alt
    }));
  }
});

exports.default = _default;
module.exports = exports.default;